import { render } from "./CardItems.vue?vue&type=template&id=6045c8ab"
import script from "./CardItems.vue?vue&type=script&lang=js"
export * from "./CardItems.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__